<div
    [innerHTML]="safeHtml"
>
</div>
